module.exports = __webpack_public_path__ + "media/46.d676b7e7.mp3";